import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card-title',
  standalone: true,
  templateUrl: './card-title.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-title.component.css',
})
export class CardTitleComponent {}
